module.exports = __webpack_public_path__ + "img/slika54.896d9fc6.jpg";